import React from 'react'

export function Show(props: {if: any; children: React.ReactElement}) {
  if (Boolean(props.if)) {
    return props.children
  }

  return null
}
